//@flow

import {ActionCreator, createReducer} from '../../store/utils';

export type ProductVisibilityState = {
  enabledFeatured?: boolean,
  enabledRecent?: boolean,
  isLoading?: boolean,
};

export type ProductVisibilityAction = {
  enabledFeatured?: boolean,
  enabledRecent?: boolean,
  isLoading?: boolean,
};

export class SetProductVisibility extends ActionCreator<ProductVisibilityAction> {}
export class SetProductVisibilityLoading extends ActionCreator<ProductVisibilityAction> {}

export const actions = {
  setProductVisibility: (payload: ProductVisibilityAction) => {
    return new SetProductVisibility({
      enabledFeatured: payload.enabledFeatured,
      enabledRecent: payload.enabledRecent,
    });
  },
  setProductVisibilityLoading: (payload: boolean) =>
    new SetProductVisibilityLoading({
      isLoading: payload,
    }),
};

export const initialState: ProductVisibilityState = {};

export default createReducer(initialState, {
  [SetProductVisibility.type]: (state, action) => {
    return {
      ...state,
      enabledFeatured: action.enabledFeatured,
      enabledRecent: action.enabledRecent,
    };
  },
  [SetProductVisibilityLoading.type]: (state, action) => {
    return {
      ...state,
      isLoading: action.isLoading,
    };
  },
});
